import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Immutable from 'immutable';

import { Taxonomy } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { VIEW_TAXONOMY_THEMES_MAX_COLUMNS_PER_ROW } from '../../../config/constants';
import type { TaxonomyTheme } from '../../../types/uncinc_profile/taxonomy';
import useTaxonomyParentIds from '../../../helpers/useTaxonomyParentIds';

interface ThemesForTargetAudiencesProps {
  entities: Immutable.List<ImmutableEntity<TaxonomyTheme>>;
}

const ThemesForTargetAudiences: React.FC<ThemesForTargetAudiencesProps> = ({ entities }) => {
  const parentIds = useTaxonomyParentIds(entities);
  const { t } = useTranslation();

  const colClassName = useMemo(() => (
    parentIds.length < VIEW_TAXONOMY_THEMES_MAX_COLUMNS_PER_ROW ? 'col-md-6' : 'col-md-6 col-xl-4'
  ), [parentIds.length]);

  if (parentIds.length === 0) {
    return null;
  }

  return (
    <>
      <h2>{t('pages.taxonomy_theme_page.subjects')}</h2>
      <div className="u-vertical-bootstrap-gutter">
        <div className="row">
          {parentIds.map((parentId) => {
            /**
             * @todo
             * Include the .find query below in the useTaxonomyParentIds.
             * That way we won't have to run this every loop sequence.
             */
            const entity = entities.find((e) => e.getIn(['tid', 0, 'value']) === parentId);
            return (
              <div className={colClassName}>
                <Taxonomy
                  key={`${parentId}:teaser`}
                  id={parentId}
                  entity={entity}
                  viewMode="teaser"
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ThemesForTargetAudiences;
